module.exports = __webpack_public_path__ + "static/media/monitor1.a86e545f.svg";